import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
import { generateQueryParams } from "../../lib/utils";

const initialState = {
  page: 0,
  rowsPerPage: 10,
  totalCashouts: 0,
  data: [],
  filters: {},
  loading: false,
  error: null,
};

const CashoutsSlice = createSlice({
  name: "cashouts",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload.cashouts;
      state.totalCashouts = action.payload.totalCashouts;
      state.loading = false;
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    },
    updateRequest: (state, action) => {
      const index = state.data.findIndex((r) => r._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
  },
});

// Actions
export const {
  requestStart,
  ApiSuccess,
  requestFailure,
  setFilters,
  setPage,
  setRowsPerPage,
  updateRequest,
} = CashoutsSlice.actions;

export const CashoutSlice = (page, limit, filters) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.get(
      `/private/backend/cashout?${generateQueryParams({
        ...filters,
        page,
        limit,
      })}`
    );
    dispatch(ApiSuccess(response.data));
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export const ApproveCashoutSlice = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.put(`/private/cashout`, data);
    dispatch(CashoutSlice());
    toast.success("Request Approved");
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export const RejectCashoutSlice = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.patch(`/private/cashout`, data);
    dispatch(CashoutSlice());
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default CashoutsSlice.reducer;
